/* ============================================
   SUVENE — Wishlist Add-to-Cart Hijack
   Statt Redirect zu /cart → Cart-Drawer öffnen
   ============================================ */

(function() {
  'use strict';

  function findVariantId(button) {
    const card = button.closest('.MuiCard-root') ||
                 button.closest('.wishlist-hero-list-card') ||
                 button.closest('[id]');
    if (!card) return null;

    const priceUpdate = card.querySelector('[id^="wishlist-hero-price-update-"]');
    if (priceUpdate) {
      const match = priceUpdate.id.match(/wishlist-hero-price-update-(\d+)/);
      if (match && match[1]) return match[1];
    }

    const priceSpan = card.querySelector('[data-wlh-item-price]');
    if (priceSpan && priceSpan.dataset.variantId) return priceSpan.dataset.variantId;

    const anyVariant = card.querySelector('[data-variant-id], [data-product-variant-id]');
    if (anyVariant) return anyVariant.dataset.variantId || anyVariant.dataset.productVariantId;

    return null;
  }

  function openCartDrawer() {
    const cartTrigger = document.querySelector('#cart-icon-bubble');
    if (!cartTrigger) return false;

    const drawer = document.querySelector('cart-drawer');
    const isOpen = drawer && (
      drawer.classList.contains('wt-cart__show-cart') ||
      drawer.classList.contains('active') ||
      drawer.hasAttribute('open')
    );
    if (isOpen) return true;

    cartTrigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    return true;
  }

  // Swiper neu initialisieren nach Cart-Update
  function reinitSwiper() {
    var attempts = 0;
    var timer = setInterval(function() {
      attempts++;
      var swiperEl = document.querySelector('.wt-slider--cross-sell .wt-slider__container');
      if (!swiperEl) { if (attempts > 20) clearInterval(timer); return; }

      // Swiper noch nicht initialisiert
      if (!swiperEl.swiper) {
        // slideshow-section Custom Element neu triggern
        var slideshowSection = document.querySelector('.wt-slider--cross-sell');
        if (slideshowSection && typeof slideshowSection.connectedCallback === 'function') {
          slideshowSection.connectedCallback();
        }
        // Alternativ: CustomEvent feuern den das Theme abhört
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (attempts > 20) clearInterval(timer);
        return;
      }

      // Swiper ist da — update aufrufen
      swiperEl.swiper.update();
      clearInterval(timer);
    }, 150);
  }

  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
  }

  async function addToCart(variantId, button) {
    if (!variantId) {
      console.warn('[Suvene] Wishlist ATC: keine Variant-ID gefunden für', button);
      return false;
    }

    button.disabled = true;
    button.style.opacity = '0.6';

    try {
      const response = await fetch(`${window.Shopify.routes.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      });

      if (!response.ok) {
        const err = await response.json();
        console.error('[Suvene] Cart add failed:', err);
        button.disabled = false;
        button.style.opacity = '';
        alert('Item konnte nicht zum Warenkorb hinzugefügt werden: ' + (err.description || err.message || 'Unbekannter Fehler'));
        return false;
      }

      const data = await response.json();
      console.log('[Suvene] Cart add success:', data);

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      refreshCartDrawer();

      // Drawer öffnen, dann Swiper fixen
      setTimeout(() => {
        openCartDrawer();
        button.disabled = false;
        button.style.opacity = '';
        // Swiper nach Drawer-Öffnung neu initialisieren
        setTimeout(reinitSwiper, 400);
      }, 300);

      return true;
    } catch (err) {
      console.error('[Suvene] Cart add error:', err);
      button.disabled = false;
      button.style.opacity = '';
      return false;
    }
  }

  function bindButton(button) {
    if (button.dataset.suHijacked === 'true') return;
    button.dataset.suHijacked = 'true';

    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      addToCart(findVariantId(button), button);
    }, true);
  }

  function bindAllButtons() {
    document.querySelectorAll('.wishlist-hero-list-card-footer-add-to-cart').forEach(bindButton);
  }

  function watchButtons() {
    bindAllButtons();
    const observer = new MutationObserver(function(mutations) {
      let needsRebind = false;
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('wishlist-hero-list-card-footer-add-to-cart')) needsRebind = true;
          if (node.querySelector && node.querySelector('.wishlist-hero-list-card-footer-add-to-cart')) needsRebind = true;
        });
      });
      if (needsRebind) bindAllButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchButtons);
  } else {
    watchButtons();
  }
})();